// @flow
import React from 'react';
import PropTypes from 'prop-types';

import './EmptyStateImage.scss';

export type Props = {
  image: string,
  mode: string,
  children: React.Node,
};

const EmptyStateImageComponent = (props: Props) => {
  const sizeClass = props.mode === 'mobile' ? '' : `empty-state-image-component--${props.mode}`;
  return (
    <div className={`empty-state-image-component ${sizeClass}`}>
      <img className="empty-state-image-component__image" src={props.image} role="presentation" alt="Empty search" />
      {props.children}
    </div>
  );
};

EmptyStateImageComponent.displayName = 'EmptyStateImage';

EmptyStateImageComponent.propTypes = {
  mode: PropTypes.oneOf(['desktop', 'mobile']),
  image: PropTypes.string.isRequired, // image import (base64-encoded string)
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

EmptyStateImageComponent.defaultProps = {
  mode: 'desktop',
};

export default EmptyStateImageComponent;
